import { OWNER_IMAGE } from "../assets";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const FAQS = [
  {
    q: "¿Quién es legalmente el inquilino de mi vivienda?",
    a: "THE NEXT ROOM. Firmamos un contrato directamente contigo como inquilino único. Nosotros somos los responsables ante ti del pago, del estado de la vivienda y de todo lo que ocurra dentro.",
  },
  {
    q: "¿Qué pasa si alguien no paga o si la vivienda está vacía?",
    a: "No es tu problema. Tú cobras tu renta puntualmente cada mes esté ocupada o no la vivienda, y al margen de si los usuarios finales pagan o no. El riesgo de impago lo asumimos nosotros.",
  },
  {
    q: "¿Quién paga las reformas y mejoras?",
    a: "THE NEXT ROOM asume los costes de reforma y revalorización necesarios para poner la vivienda al máximo rendimiento. Tras la visita inicial te detallamos qué se va a hacer y bajo qué condiciones.",
  },
  {
    q: "¿Sigo teniendo acceso a mi vivienda?",
    a: "Sí. Mantienes en todo momento la propiedad y el acceso a tu inmueble. Coordinamos las visitas contigo para no interferir con los residentes.",
  },
  {
    q: "¿Cuánto cobro y cuándo?",
    a: "El importe lo definimos contigo tras evaluar la vivienda y la ubicación. Una vez firmado el contrato, ingresamos la renta acordada los primeros días de cada mes, sin demoras.",
  },
  {
    q: "¿Qué ocurre al finalizar el contrato?",
    a: "Te devolvemos la vivienda en igual o mejor estado del entregado. La duración del contrato y las condiciones de salida se acuerdan desde el día uno, sin sorpresas.",
  },
];

export default function ForOwners() {
  return (
    <section data-testid="owners-section" className="nr-section">
      <div className="nr-container grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <div className="rounded-3xl overflow-hidden border border-[#EAEAEA] sticky top-28">
            <img
              src={OWNER_IMAGE}
              alt="Interior residencial moderno y luminoso"
              className="w-full h-[520px] object-cover"
            />
          </div>
        </div>

        <div className="lg:col-span-7">
          <span className="nr-eyebrow">Para propietarios</span>
          <h2 className="nr-h2 mt-4">
            Resolvemos tus dudas antes de la primera llamada.
          </h2>
          <p className="mt-5 text-[16px] nr-text-soft max-w-[560px]">
            Las preguntas más habituales de propietarios e inversores. Sin
            tecnicismos, sin letra pequeña, sin compromiso.
          </p>

          <div className="mt-10">
            <Accordion type="single" collapsible className="w-full">
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={f.q}
                  value={`item-${i}`}
                  className="border-b border-[#EAEAEA]"
                  data-testid={`faq-${i}`}
                >
                  <AccordionTrigger className="text-left font-sub text-[16px] md:text-[17px] hover:no-underline py-5">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-[15px] nr-text-soft leading-relaxed pb-5">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
